import { Capacitor } from '@capacitor/core';
import { DeviceInformation } from '../../../capacitor_plugins/deviceInformation';
import { CAPACITOR_DEVICE_INFORMATION_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import globalLogger from '../../logger';
import { isPlatformAndroid } from '../../platform/utils/platformDetailsUtils';
import platformSingleton from '../../platform/platformSingleton';

const logger = globalLogger.createChannel('mobile.navigationBarHeight');

/**
 * Adds the navigation bar height to the root element
 * This is used to create a bar under **Androids** navigation buttons when in 'light' mode
 * to prevent the buttons from being washed out but the bottom toolbar.
 */
export const addNavigationBarValues = async () => {
    if (!isPlatformAndroid(platformSingleton)) return;
    if (!Capacitor.isPluginAvailable(CAPACITOR_DEVICE_INFORMATION_PLUGIN)) {
        // As it's hard to detect the navigation mode from a browser, default to gesture nav behaviour
        document.body.classList.add('android-gesture-nav');
        return;
    }

    try {
        const { mode, height = 0 } = await DeviceInformation.getNavBarInfo();
        const isGesture = mode === 'gesture' || height === 0;
        document.body.classList.toggle('android-gesture-nav', isGesture);
        document.body.style.setProperty('--nav-bar-height', `${height}px`);
    } catch (error) {
        logger.error('Failed to add navigation bar values', error);
    }
};
